<div class="title" mat-dialog-title>
  <p>Send ny BankID-lenke</p>
  <app-ice-icon-button
    ariaLabel="Lukk dialog"
    matDialogClose
    size="32px"
    testId="close-new-bankid-verification-modal"
    [iconName]="IconNames.ice_close"
  />
</div>
<div class="content" mat-dialog-content>
  <app-ice-alert type="info" [iconName]="IconNames.ice_info">
    Ny utsendelse av BankID (SMS eller e-post) overskriver tidligere lenker. Kunden må alltid bruke den nyeste lenken for å
    verifisere seg med BankID.
  </app-ice-alert>
  <app-bank-id-input
    testId="bankid-msisdn-order-details"
    [autoUpdateStore]="false"
    [displayBypassOption]="false"
    [initialEmail]="initialEmail"
    [initialPhoneNumber]="initialPhoneNumber"
    [shouldUsePadding]="false"
    [showButton]="true"
    (sendBankIdVerification)="sendNewBankIdLink($event)"
  />
</div>
